import script from "./JourneySearchTable.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneySearchTable.vue?vue&type=script&setup=true&lang=js"

import "./JourneySearchTable.vue?vue&type=style&index=0&id=bb6924ca&lang=css"

const __exports__ = script;

export default __exports__